import DownloadIcon from '@mui/icons-material/Download';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/ui/text';
import { Tooltip } from '@/components/ui/tooltip';
import { usePrefValue } from '@/preferences';
import { ExportButton } from './ExportScript.styles';

export const ExportScript = () => {
    const { t } = useTranslation();
    const side_bar = usePrefValue('side_bar');

    return (
        <ExportButton sideBar={side_bar} disabled>
            {side_bar ? (
                <>
                    <DownloadIcon fontSize="small" />
                    <Text variant="body2" color="text-inherit" children={t('synopsis-page.export-script')} />
                </>
            ) : (
                <Tooltip
                    title={<Typography variant="body2" color={theme => theme.custom.c22} children={t('synopsis-page.export-script')} />}
                    disableInteractive
                    placement="left"
                    sideOffset={8}
                    contentClassName="py-2 pr-3 pl-0 bg-bg-paper"
                >
                    <div className="flex">
                        <DownloadIcon fontSize="small" />
                    </div>
                </Tooltip>
            )}
        </ExportButton>
    );
};
